import { useEffect } from "react";

export const useHypercomments = (card) => {
  useEffect(() => {
    async function fetchComments(commentsLink) {
      try {
        const response = await fetch(
          `https://www.rebusmetod.com/ya-pochynayu-chytaty/komentari/${
            commentsLink?.value ?? ""
          }/`
        );
        if (!response.ok) {
          console.error(
            `Network response was not ok. Status: ${response.status} - ${response.statusText}`
          );
          throw new Error("Network response was not ok");
        }

        const html = await response.text();
        const container = document.createElement("div");
        container.innerHTML = html;
        const textContainer = container.querySelector(".comments-area");

        const hyperCommentsWidgets = document.querySelectorAll(
          ".slick-slide:not(.slick-cloned) .hyper-comments"
        );
        hyperCommentsWidgets.forEach((widget) => {
          if (!widget.childNodes.length) widget.appendChild(textContainer);
        });
      } catch (error) {
        console.error("Error fetching comments:", error);
      }
    }
    if (!card || !card?.streamlinedArticle?.content) return;
    const commentsLink = card?.streamlinedArticle?.content.filter(
      (item) => item.type === "hyperComments"
    );
    commentsLink.length && fetchComments(commentsLink.shift());
  }, [card]);
};
